import { Space, Typography, Tag, Tooltip } from 'antd';
import moment from 'moment';
import { useSelector } from 'react-redux';

const { Text } = Typography;

const ChatMetaData = () => {
  const { selectedWebChatConversation } = useSelector((state) => state.inbox);

  return (
    <div className="flex-column weight-medium align-start gap-0 min-w-[310px] overflow-hidden">
      <Space>
        <Text className="overflow-hidden text-ellipsis w-[100px] text-nowrap">
          {selectedWebChatConversation?.agent_session_id} Chat with user:{' '}
          {'Unknown'}
        </Text>
      </Space>

      <Space
        // className="flex-wrap"
        split={<Text style={{ margin: '0 1px' }}>·</Text>}
      >
        <Tag className="m-0" color="#87d068">
          EN
        </Tag>
        <Tooltip
          color="white"
          title={
            <Text>
              {moment(selectedWebChatConversation?.created_at).format(
                'DD-MM-YYYY HH:mm:ss',
              )}
            </Text>
          }
          placement="bottom"
        >
          <Text className="text-xs text-[#8c8c8c] cursor-pointer overflow-hidden text-ellipsis w-[100px] text-nowrap">
            Created: {moment(selectedWebChatConversation?.created_at).fromNow()}
          </Text>
        </Tooltip>
        <Tooltip
          color="white"
          title={
            <Text>
              {moment(selectedWebChatConversation?.last_message_time).format(
                'DD-MM-YYYY HH:mm:ss',
              )}
            </Text>
          }
          placement="bottom"
        >
          <Text className="text-xs text-[#8c8c8c] cursor-pointer overflow-hidden text-ellipsis w-[100px] text-nowrap">
            Updated:{' '}
            {moment(selectedWebChatConversation?.last_message_time).fromNow()}
          </Text>
        </Tooltip>
      </Space>
    </div>
  );
};

export default ChatMetaData;
